"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.4 6.419v11.497l.128-.035c.74-.194 1.838-.381 3.322-.381s2.582.187 3.322.381l.128.035V6.42a5 5 0 0 0-.53-.211c-.61-.207-1.572-.425-2.92-.425s-2.31.218-2.92.425a5 5 0 0 0-.53.21M12 5.202a6 6 0 0 0-.782-.32c-.753-.255-1.866-.499-3.368-.499s-2.615.244-3.368.498a6 6 0 0 0-.857.36 4 4 0 0 0-.317.184l-.007.006-.003.002h-.002v.001l.404.572-.405-.571a.7.7 0 0 0-.295.57v12.912a.7.7 0 0 0 1.033.615h.002l.028-.014q.042-.021.147-.064c.14-.056.363-.137.674-.219.623-.163 1.6-.335 2.966-.335s2.343.172 2.966.335c.311.082.535.163.674.219a3 3 0 0 1 .177.078.7.7 0 0 0 .666 0h.002l.028-.014q.042-.021.147-.064c.14-.056.363-.137.674-.219.623-.163 1.6-.335 2.966-.335s2.343.172 2.966.335c.311.082.535.163.674.219a3 3 0 0 1 .175.077l.002.001A.7.7 0 0 0 21 18.917V6.006a.7.7 0 0 0-.295-.571l-.405.57.404-.57v-.001l-.002-.001-.003-.002-.007-.006a1 1 0 0 0-.087-.056 4 4 0 0 0-.23-.129 6 6 0 0 0-.857-.359c-.753-.254-1.866-.498-3.368-.498s-2.615.244-3.368.498a6 6 0 0 0-.782.321m7.6 1.217a5 5 0 0 0-.53-.211c-.61-.207-1.572-.425-2.92-.425s-2.31.218-2.92.425a5 5 0 0 0-.53.21v11.498l.128-.035c.74-.194 1.838-.381 3.322-.381s2.582.187 3.322.381l.128.035zm.363 13.111",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=OpenBookIcon24.js.map